import { IconWithText } from "@/design-system/Atoms";

interface HeroFeatureListProps {
    features: { icon: string; text: string }[];
}

const HeroFeatureList = ({ features }: HeroFeatureListProps) => (
    <div className="rounded-[20px] bg-white/5 backdrop-blur-[20px] ms-0 lg:ms-[2rem]">
        <div className="grid grid-cols-2 p-6 md:p-8 gap-4 md:gap-5">
            {features.map(({ icon, text }, i) => (
                <IconWithText key={i} icon={icon} text={text} />
            ))}
        </div>
    </div>
);

export default HeroFeatureList;
